import type { EventFilters } from '@/features/publicsite/types/events/EventFilters';
import type { EventOrder } from '@/features/publicsite/types/events/EventOrder';

/**
 * The two directions the calendar endpoint orders by, as it names them. Sent on every request: the
 * server's default depends on the shape of the answer — `desc` for a page, `asc` for the bare array
 * it still serves — so a request that left it out would flip direction the day this page stopped
 * paging.
 */
export const EVENT_ORDER = { asc: 'asc', desc: 'desc' } as const;

/**
 * Which way round the calendar reads, from the period alone.
 *
 * A period that starts today or later is a question about what is coming, so the nearest event
 * comes first; anything else — a period that reaches into the past, or no period at all — is a
 * question about what happened, so the most recent comes first. The page is one list now, and the
 * first page is the one a visitor sees: which end of the calendar it opens on is the whole of what
 * the old "Evenimente viitoare" heading used to decide.
 *
 * `today` is passed in rather than read here: this is the only thing on the page that depends on
 * the date, and a function that called the clock itself could not be tested on either side of it.
 */
export function calendarOrder(filters: Pick<EventFilters, 'from'>, today: string): EventOrder {
  return filters.from && filters.from >= today ? EVENT_ORDER.asc : EVENT_ORDER.desc;
}
